import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDeal } from '../contexts/DealContext';

interface DealRouteGuardProps {
  children: React.ReactNode;
}

export function DealRouteGuard({ children }: DealRouteGuardProps) {
  const { dealId } = useParams<{ dealId: string }>();
  const navigate = useNavigate();
  const { selectedDeal, availableDeals, isLoading } = useDeal();

  useEffect(() => {
    // Only check if we have a dealId in the route, we're not loading, AND we have deals loaded
    if (dealId && !isLoading && availableDeals.length > 0) {
      // Check if the deal exists in available deals
      const dealExists = availableDeals.some(deal => deal.deal_id === dealId);
      
      if (!dealExists) {
        // If the deal doesn't exist, redirect to the deals page
        console.log(`Deal ${dealId} not found, redirecting to deals page`);
        navigate('/deals', { replace: true });
      }
    }
  }, [dealId, availableDeals, isLoading, navigate]);

  // If we're loading or the deal doesn't exist (and we have deals loaded), don't render children
  if (isLoading || (dealId && availableDeals.length > 0 && !availableDeals.some(deal => deal.deal_id === dealId))) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">
            {isLoading ? 'Loading...' : 'Deal not found'}
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

